import React from 'react'
import { debounce } from 'lodash-es'
import { api } from 'components/api'
import { supplierSearchPath } from 'components/routes/api'
import { editSupplierOnboardingPath, createSupplierOnboardingPath } from 'components/routes/path'

class OnboardingSupplierSearch extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      searchResults: [],
      search: '',
      hideCreateSupplier: true
    }
  }

  async searchSuppliers (e) {
    const search = e.currentTarget.value
    this.setState({ search })

    if (search.length < 3 && search.length > 0) return null

    const suppliers = await api.get({
      url: supplierSearchPath(),
      params: {
        query: search
      }
    })

    this.setState({ searchResults: suppliers.data, hideCreateSupplier: false })
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') e.target.blur()
  }

  createNewSupplier = (e) => {
    e.persist()

    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        api.postWithCsrf({
          url: createSupplierOnboardingPath(),
          data: {
            search: this.state.search
          }
        })
          .then((response) => {
            location.pathname = editSupplierOnboardingPath(
              response.data.id
            )
          })
      }, 300)
    }
    this.debouncedFn()
  }

  selectFoundSupplier = (selectedSearchResponse) => {
    const lookup = selectedSearchResponse.slug || selectedSearchResponse.id
    location.pathname = editSupplierOnboardingPath(lookup)
  }

  get dropdownSelections () {
    if (this.state.hideCreateSupplier) return null

    return (
      <div className='results-list'>
        <div
          className='new-business'
          onClick={(e) => {
            this.createNewSupplier(e)
          }}
        >
          <div className='left-content'>
            <p>{this.state.search}</p>
            <p>Create a business with this name &rarr;</p>
          </div>
          <div className='right-content' />
        </div>
        {this.state.searchResults.map((d) => (
          <div
            key={`${d.name}-${d.id}`}
            className='search-result'
            onClick={() => {
              this.selectFoundSupplier(d)
            }}
          >
            <p>{d.name}</p>
            <p>{d.location}</p>
          </div>
        ))}
      </div>
    )
  }

  render () {
    return (
      <div>
        <input
          name='supplier-search-input'
          value={this.state.search}
          placeholder='Search for your business name'
          onChange={(e) => {
            this.searchSuppliers(e)
          }}
          onKeyDown={(e) => {
            this.handleKeyDown(e)
          }}
        />
        {this.dropdownSelections}
      </div>
    )
  }
}

export default OnboardingSupplierSearch
